module.exports = __webpack_public_path__ + "static/img/13.98c052a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/13.png
// module id = cmj7
// module chunks = 1